import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ChartWidgetModel } from '../../models/widget-related/ChartWidgetModel';
import { PreloaderHandler, DOTS_FULL, MULTICOLOR_FULL, BLUE_FULL } from '../../preloader/preloader-handler';
import { ChartWidgetService } from './chart-widget.service';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { NotificationHandlerService } from '../../notifications/notification-handler.service';

@Component({
    selector: 'chart-widget',
    templateUrl: 'chart-widget.component.html'
})

export class ChartWidgetComponent implements OnInit {

    @Input() widget: string;
    @Input() widgetId: string;
    @Output() export = new EventEmitter();
    public data: any;
    public preloaderHandler: PreloaderHandler;

    constructor(private _widgetService: ChartWidgetService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL);
    }

    ngOnInit(): void {
        this.getData();
    }

    private exportData(): void {
        this.export.emit(this.data);
    }

    private refreshData(): void {
        this.preloaderHandler.reset();
        this.getData();
    }

    private getData(): void {
        this._widgetService
            .Get(this.widget, this.widgetId)
            .subscribe(data => {
                this.data = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.preloaderHandler.itemLoaded()
            });
    }

}



// WEBPACK FOOTER //
// ./angularApp/app/shared/chart-widget-container/chart-widget/chart-widget.component.ts